import { render, staticRenderFns } from "./providerPublishTable.vue?vue&type=template&id=415559fc"
import script from "./providerPublishTable.vue?vue&type=script&lang=js"
export * from "./providerPublishTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports